<template>
  <div>
    <div class="mt-10 d-flex justify-space-between heading-2">
      <div>Membership</div>
      <div class="d-flex align-center">
        <v-btn
          rounded
          outlined
          color="#1884CD"
          class="px-9 mr-3"
          @click="PaymentProcessDialog = true"
          dark
          style="
            text-transform: none !important;

            border: 1px solid #d2e5fc;
          "
          >Add Payment</v-btn
        >

            <div class="d-flex d-flex justify-space-between">
              <v-btn
                rounded
                outlined
                color="#1884CD"
                class="px-9"
                dark
                @click="Membereditdialog = true"
                style="
                  text-transform: none !important;

                  border: 1px solid #d2e5fc;
                "
                >Edit</v-btn
              >
            </div>
          <v-dialog v-model="Membereditdialog" width="500" persistent>
          <v-card v-if="Membereditdialog">
            <div>
              <membership-view @close="close"/>
            </div>
          </v-card>
        </v-dialog>
      </div>
    </div>

    <div class="mt-4 mb-12">
      <v-card flat style="width: 500px">
        <v-row class="mt-2">
          <v-col cols="12" md="4">
            <div><span class="style_txt_hh1">User/Membership Type</span></div>
          </v-col>
          <v-col cols="12" md="8">
            <div>
              <span class="style_txt_hh2">
                <!-- <span v-if="getMembershipByUserId?.MembershipStatus == 4">{{previousMembershipName}}</span>
                <span v-else>{{ getMembershipByUserId ? getMembershipByUserId.Name : "" }}</span> -->
                <span>{{ getMembershipByUserId ? getMembershipByUserId.Name : "" }}</span>
              </span>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-1">
          <v-col cols="12" md="4">
            <div><span class="style_txt_hh1">Amount</span></div>
          </v-col>
          <v-col cols="12" md="8">
            <div>
              <span class="style_txt_hh2"
                >${{ getAmount }}
                / year
              </span>
            </div>
          </v-col>
        </v-row>
        <v-row class="mt-1">
          <v-col cols="12" md="4">
            <div>
              <span class="style_txt_hh1">Date of membership</span>
            </div>
          </v-col>
          <v-col cols="12" md="8">
            <div
              v-if="
                getMembershipByUserId.StartDateTime &&
                getMembershipByUserId.EndDateTime
              "
            >
              <span class="style_txt_hh2">{{
                getMembershipByUserId
                  ? `${getMembershipByUserId.StartDateTime.split("T")[0]} - ${
                      getMembershipByUserId.EndDateTime.split("T")[0]
                    }`
                  : ""
              }}</span>
            </div>
          </v-col>
        </v-row>
        <v-row class="mt-1">
          <v-col cols="12" md="4">
            <div><span class="style_txt_hh1">Auto Renewal</span></div>
          </v-col>
          <v-col cols="12" md="8">
            <div>
              <span class="style_txt_hh2">
                <span v-if="getMembershipByUserId.AutoRenewal">Yes</span>
                <span v-else>No</span>
              </span>
            </div>
          </v-col>
        </v-row>
        <!-- <v-row class="mt-1">
          <v-col cols="12" md="3">
            <span class="style_txt_hh1">
              <router-link to="/users/profile" class="text-decoration-underline"
                >Add Payment
              </router-link>
            </span>
          </v-col>
        </v-row> -->
      </v-card>
    </div>

    <v-divider
      class="my-7 mt-4"
      style="opacity: 0.1; border: 1px solid #000000"
    >
    </v-divider>

    <div class="mt-6 mb-8 d-flex justify-space-between heading-2">
      Invoices

      <v-dialog v-model="billingeditdialog" width="500" persistent>
        <!-- <template v-slot:activator="{ on, attrs }" class="px-10">
          <div class="d-flex d-flex justify-space-between">
            <v-btn
              rounded
              outlined
              color="primary"
              class="px-4 stying_text"
              dark
              v-bind="attrs"
              v-on="on"
              >Edit Billing Info</v-btn
            >
          </div>
        </template> -->
        <v-card>
          <!-- <div class="mx-5 py-5 d-flex justify-space-between">
            <h5>Billing Info</h5>
            <v-icon @click="billingeditdialog = false">mdi-close</v-icon>
          </div> -->
          <div>
            <billing-inf-edit
              billingeditdialog="billingeditdialog"
              @close="close"
            />
          </div>
          <!-- <div class="d-flex justify-end mx-5 py-5 pt-8 pb-8">
            <v-btn
              class="px-10 py-6 text_transform"
              color="#A1A3A8"
              text
              @click="billingeditdialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              depressed
              color="primary"
              class="px-14 py-6 text_transform"
              :disabled="btnloader"
              @click="send()"
            >
              <span v-if="btnloader != true"> Save </span>
              <v-progress-circular
                indeterminate
                size="20"
                class="px-5"
                color="white"
                v-show="btnloader"
              ></v-progress-circular>
            </v-btn>
          </div> -->
        </v-card>
      </v-dialog>
    </div>

    <v-card class="mt-2 mb-14" outlined flat>
      <v-data-table
        :headers="headers"
        :items="getMembershipInvoicesByUserId.Data"
        :loading="btnloader"
        disable-pagination
        :hide-default-footer="true"
        class="mytable"
      >
        <template v-slot:[`item.index`]="{ index }">
          <b class="index_index_text">
            {{ index + 1 }}
          </b>
        </template>
        <template v-slot:[`item.MembershipID`]="{ item }">
          {{ getMembershipLabel(item.MembershipID) }}
        </template>
        <template v-slot:[`item.Amount`]="{ item }">
          {{ item.Amount?.toFixed(2) }}
        </template>
        <template v-slot:[`item.DateProcessed`]="{ item }">
            {{ item.DateProcessed && item.DateProcessed?.split("T")[0] }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon color="#A1A1A6" @click="openInvoiceRecord(item)">
            mdi-file-document
          </v-icon>
          <v-icon color="#A1A1A6" class="pl-2" @click="openDeleteDialog(item.InvoicesID)"> mdi-delete </v-icon>
          <v-dialog v-model="deletedialog" persistent max-width="290">
            <v-card>
              <v-card-title class="text-h5">Warning</v-card-title>
              <v-card-text class="index_span_2_style"
                >Are you sure you want to delete?</v-card-text
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="closeDeleteDialog">
                  Cancel
                </v-btn>
                <v-btn
                  color="primary"
                  :disabled="btnloader"
                  @click="deleteInvoice(selectedInvoiceId)"
                >
                  <span v-if="btnloader != true" >Confirm</span>
                  <v-progress-circular
                    indeterminate
                    v-else
                    size="20"
                    class="px-5"
                    color="white"
                    v-show="btnloader"
                  ></v-progress-circular>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </v-data-table>
    </v-card>
    
    <v-dialog
      v-model="invoicedialog"
      max-width="680"
      @click:outside="closeDialog"
    >
      <div>
        <invoices :invoiceRecord="data" :getMembershipLabel="getMembershipLabel" :GetInstructorLicensingDetails="GetInstructorLicensingDetails"/>
      </div>
    </v-dialog>
    <!------------------------Add Payment ------------------------------------->
    <v-dialog max-width="600" v-model="PaymentProcessDialog" persistent>
      <v-card class="px-8 pt-8 pb-8" v-if="PaymentProcessDialog">
        <UserPaymentComponent
          :PaymentProcess="PaymentProcessDialog"
          @close="close"
        ></UserPaymentComponent>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BillingInfEdit from "../BillingInfEdit.vue";
import invoices from "../invoices.vue";
import MembershipView from "../MembershipView.vue";
import UserPaymentComponent from "../../../components/Users/paymentcomponents/UserPayment.component.vue";
export default {
  components: {
    UserPaymentComponent,
    MembershipView,
    BillingInfEdit,
    invoices,
  },
  computed: {
    ...mapGetters([
      "getMembershipInvoicesByUserId",
      "GetPreviewUser",
      "getMembershipByUserId",
      "GetInstructorLicensingDetails"
    ]),
    previousMembershipName() {
      const membershipMap = {
        1: "Starter",
        2: "Access",
        3: "Standard",
        4: "Practitioner",
        5: "Instructor",
        6: "LifeSciences",
        7: "Deceased",
        8: "InActive",
        9: "Trainee Instructor",
        10: "Senior Instructor",
      };
      return membershipMap[this.getMembershipByUserId?.PreviousMembershipID] || 'Unknown';
    },
    isEndDateInTheFuture() {
      const endDate = this.getMembershipByUserId?.EndDateTime?.split("T")[0];
      return endDate && new Date(endDate) > new Date();
    },
    getAmount() {
      switch (this.getMembershipByUserId.Name) {
        case "Public access":
        case "Starter":
        case "Deceased":
        case "Inactive":
          return 0;

        case "Access":
          return 40;

        case "Standard":
          return 150;

        case "Practitioner":
        case "Instructor":
        case "Trainee Instructor":
        case "Senior Instructor":
          return 300;

        default:
          return 0;
      }
    },
    getMembershipLabel() {
      return (membershipLevel) => {
        switch (membershipLevel) {
          case 1:
            return "Starter";
          case 2:
            return "Access";
          case 3:
            return "Standard";
          case 4:
            return "Practitioner";
          case 5:
            return "Instructor";
          case 6:
            return "LifeSciences";
          case 7:
            return "Deceased";
          case 8:
            return "InActive";
          case 9:
            return "Trainee Instructor";
          case 10:
            return "Senior Instructor";
          default:
            return "";
        }
      };
    },
  },
  name: "seeprofilecomponent",
  data() {
    return {
      data: null,
      PaymentProcessDialog: false,
      editAddressdialog: false,
      deletedialog:false,
      selectedInvoiceId: null,
      invoicedialog: false,
      Memberinfoeditdialog: false,
      Membereditdialog: false,
      billingeditdialog: false,
      addreseditdialog: false,
      btnloader: false,
      btnloader1: false,
      add_dialog: false,
      dialog: false,
      name: "axel",
      LastName: "Camelatti",
      addressitems: [
        { address: "calle 142,1480,Breaztegui 1448, Areis" },
        { address: "calle 142,1480,Breaztegui 1448, Areis" },
      ],
      invoicesData:[],
      headers: [
        { text: "#", value: "index", sortable: false },
        { text: "Date processed", value: "DateProcessed", sortable: false },
        // {
        //   text: "Payment made through",
        //   value: "paymentmade",
        //   sortable: false,
        // },
        { text: "Membership", value: "MembershipID", sortable: false },
        { text: "Amount", value: "Amount", sortable: false },
        // { text: "Payment Made by", value: "paymentmadeby", sortable: false },
        { text: "Invoice", value: "actions", sortable: false },
      ],
      DataTableOne: [
        {
          index: 4,
          dateat: "11/12/2021",
          paymentmade: "Website",
          membership: "Practitioner",
          amount: "$99.99",
          paymentmadeby: "Member",
        },
        {
          index: 3,
          dateat: "11/12/2021",
          paymentmade: "Admin",
          membership: "Practitioner",
          amount: "$99.99",
          paymentmadeby: "IBA Team",
        },
        {
          index: 2,
          dateat: "11/12/2021",
          paymentmade: "Website",
          membership: "Practitioner",
          amount: "$99.99",
          paymentmadeby: "Member",
        },
        {
          index: 1,
          dateat: "11/12/2021",
          paymentmade: "Admin",
          membership: "Practitioner",
          amount: "$99.99",
          paymentmadeby: "IBA Team",
        },
      ],
      tabs: null,
    };
  },
  mounted() {
    this.fetchInvoiceData()
    this.$store.dispatch("GetInstructorLicensingDetails",this.GetPreviewUser.Id);
    // this.$store.dispatch("GetBillingDetailsInfoByUserId", obj);
  },
  methods: {
    openInvoiceRecord(invoiveData){
      this.data = invoiveData
      this.invoicedialog = true
    },
    openDeleteDialog(invoiceId) {
      this.selectedInvoiceId = invoiceId;
      this.deletedialog = true;
    },
    closeDeleteDialog() {
      this.deletedialog = false;
      this.selectedInvoiceId = null; // Reset selected exam
    },
    fetchInvoiceData(){
      const obj = {
      ID: this.GetPreviewUser.Id,
    };
    this.btnloader = true;
    this.$store.dispatch("GetMembershipInvoicesByUserId", obj).then(() => {
      this.btnloader = false;
    });
    },
    deleteInvoice(id){
      this.btnloader = true;
      this.$store.dispatch("DeleteMembershipInvoice", id).then(()=>{
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Invoice Deleted Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        this.fetchInvoiceData()
        this.deletedialog = false;
        this.btnloader = false;
      })
    },
    close() {
      this.editdialog = false;
      this.editexam = false;
      this.addreseditdialog = false;
      this.add_dialog = false;
      this.snackbar = true;
      this.PaymentProcessDialog = false;
      this.billingeditdialog = false;
      this.Membereditdialog = false
      this.fetchInvoiceData()
    },
    closeDialog() {
      this.add_dialog = false;
      this.value = false;
    },
    DdialogClose() {
      this.dialog = false;
      this.Deletesnackbar = true;
    },
    snackbarClose() {
      // this.snackbar = false;
      this.Deletesnackbar = false;
    },
    openadddialog() {
      this.add_dialog = true;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.Membereditdialog = false;
        this.billingeditdialog = false;
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Edited Successfully",
          showConfirmButton: false,
          timer: 1500,
        });

        this.btnloader = false;
      }, 2000);
    },
  },
};
</script>
<style scoped>
.tabs_slider {
  color: #1884cd;
  font-weight: 800;
  font-size: 16px;
  line-height: 21px;
  border-bottom: 2px solid #e1e4e7;
}
.style_txt_hh1 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: rgba(34, 34, 34, 0.7);
}
.style_txt_hh2 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  color: #222222;
}
.devider_style {
  width: 590px;
  left: 326px;
  top: 729px;
  opacity: 0.1;
  border: 1px solid #000000;
}
.text_transform {
  text-transform: none;
}
.stying_text {
  text-transform: none !important;
  border: 1px solid #d2e5fc;
}
.text-center {
  text-align: center !important;
}
</style>
